<template>
    <div class="audit" v-loading="loading">

        <PageTitle
            :text="pageTitle"
        >
        </PageTitle>

        <div class="padding">

            <div style="padding-bottom: 20px">
                <p>{{ pageDescription }}</p>
            </div>

            <div
                class="form-container padding shadow"
                style="padding-top:40px; margin-bottom:20px;">
                <el-form
                    ref="siteForm"
                    :model="form"
                    :rules="rules"
                    label-position="left"
                    label-width="280px"
                    class="site-form"
                >

                    <div class="form-part">
                        <div>
                            <h2 class="step-title">Site</h2>
                        </div>
                        <el-form-item
                            label="Entreprise"
                            prop="company"
                        >
                            <el-input
                                v-model="form.company"
                                style="width:100%">
                            </el-input>
                        </el-form-item>

                        <el-form-item
                            label="Nom de l'établissement"
                            prop="facility"
                        >
                            <el-input
                                v-model="form.facility"
                                style="width:100%">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="Client" prop="client" v-if="userIsAtLeastManager">
                            <el-input
                                v-model="form.client"
                                style="width:100%">
                            </el-input>
                        </el-form-item>
                        <el-form-item
                            label="Adresse"
                            prop="address"
                        >
                            <el-input
                                v-model="form.address"
                                style="width:100%">
                            </el-input>
                        </el-form-item>
                        <el-form-item
                            label="Ville"
                            prop="city"
                        >
                            <el-input
                                v-model="form.city"
                                style="width:100%">
                            </el-input>
                        </el-form-item>

                        <el-form-item
                            label="Code postal"
                            prop="zip_code"
                        >
                            <el-input
                                v-model="form.zip_code"
                                style="width:100%">
                            </el-input>
                        </el-form-item>
                        <el-form-item
                            label="Compteur d'énergie"
                            prop="energy_meter"
                        >
                            <el-select
                                v-model="form.energy_meter"
                                style="width:100%"
                            >
                                <el-option
                                    v-for="meter in energyMetersSite"
                                    :key="meter.key"
                                    :label="meter.value"
                                    :value="meter.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="Numéro du compteur"
                            prop="energy_meter_name"
                        >
                            <el-input
                                v-model="form.energy_meter_name"
                                style="width:100%"
                            >
                                <template slot="prepend">{{ energyMetersPrefix(form.energy_meter) }}</template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="form-part">
                        <div>
                            <h2 class="step-title">Données électriques</h2>
                        </div>
                        <el-form-item
                            label="Puissance souscrite (kVA)"
                            prop="subscribed_power_kva"
                        >
                            <el-input-number
                                v-model="form.subscribed_power_kva"
                                :controls="false"
                                :precision="0"
                                :min="1"
                                style="width:100%">
                            </el-input-number>
                        </el-form-item>
                        <el-form-item
                            label="Prix du MWh (€)"
                            prop="mwh_price"
                        >
                            <el-input-number
                                v-model="form.mwh_price"
                                :controls="false"
                                :min="0"
                                style="width:100%">
                            </el-input-number>
                        </el-form-item>
                         <el-form-item
                            label="Puissance du talon (kW)"
                            prop="baseload_power_is_known"
                        >
                            <el-radio-group
                                v-model="form.baseload_power_is_known"
                            >
                                <el-radio
                                    :label="true">
                                    Connue
                                </el-radio>
                                <el-radio
                                    :label="false">
                                    Inconnue (Pmin mesurée)
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                         <el-form-item
                            v-if="form.baseload_power_is_known"
                            prop="baseload_power_kw"
                        >
                            <el-input-number
                                v-model="form.baseload_power_kw"
                                :controls="false"
                                :min="0"
                                style="width:100%">
                            </el-input-number>
                        </el-form-item>
                        <el-form-item
                            label="Etude de la reduction du reactif"
                            prop="reactive_power_reduction_study"
                        >
                            <el-radio-group
                                v-model="form.reactive_power_reduction_study"
                                @change="resetReactiveStudyFields"
                            >
                                <el-radio
                                    :label="true">
                                    Oui
                                </el-radio>
                                <el-radio
                                    :label="false">
                                    Non
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <template
                            v-if="form.reactive_power_reduction_study"
                        >
                            <el-form-item
                                label="Tan Phi contractuel"
                                prop="contractual_tan_phi"
                            >
                                <el-input-number
                                    v-model="form.contractual_tan_phi"
                                    :controls="false"
                                    :precision="2" 
                                    :min="0"
                                    style="width:100%">
                                </el-input-number>
                            </el-form-item>
                            <el-form-item
                                label="Tan Phi cible"
                                prop="target_tan_phi"
                            >
                                <el-input-number
                                    v-model="form.target_tan_phi"
                                    :controls="false"
                                    :precision="2" 
                                    :min="0"
                                    style="width:100%">
                                </el-input-number>
                            </el-form-item>
                            <el-form-item
                                label="Compensation existante"
                                prop="existing_compensation"
                            >
                                <el-radio-group
                                    v-model="form.existing_compensation"
                                    @change="resetExistingCompensationFields"
                                >
                                    <el-radio
                                        :label="true">
                                        Oui
                                    </el-radio>
                                    <el-radio
                                        :label="false">
                                        Non
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                v-if="form.existing_compensation"
                                label="Puissance de la batterie (kVAR)"
                                prop="battery_power_kvar"
                            >
                                <el-input-number
                                    v-model="form.battery_power_kvar"
                                    :controls="false"
                                    :min="0"
                                    style="width:100%">
                                </el-input-number>
                            </el-form-item>
                        </template>
                    </div>
                    <el-form-item class="button-container">
                        <el-button
                            type="primary"
                            icon="el-icon-check"
                            @click="save">
                            Enregistrer
                        </el-button>
                        <el-button
                            icon="el-icon-close"
                            @click="leaveSite">
                            Annuler
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitle from '@/components/partials/ui/PageTitle';
import FormHelp from '@/components/partials/ui/FormHelp';
import { min } from 'lodash';

export default {
    name: 'Motor',
    components: {
        PageTitle,
        FormHelp
    },
    data () {
        var validateEnergyMeterName = (rule, value, callback)=>{
            if (value === '') {
            callback(new Error('Le numéro du compteur d\'énergie est obligatoire'));
            } else if(!Number.isInteger(parseInt(value))){
                callback(new Error('Le numéro du compteur doit être un entier'));
            }else if (
                this.currentEnergyMeterNames.includes(this.energyMeterFullName) 
                && this.energyMeterFullName !== this.currentSite.energy_meter_name
            ) {
              callback(new Error('Un compteur existe déjà avec ce nom'));
            } else {
              callback();
            }
        };
        var validateSubscribedPower = (rule, value, callback)=>{
            if (!Number.isInteger(value)) {
            callback(new Error('La valeur doit être un entier'));
            } else if (value < 1 || value > 100000) {
              callback(new Error('La puissance souscrite doit être comprise entre 1 et 100000 kVA'));
            } else {
              callback();
            }
        };
        let validatePrice = (rule, value, callback)=>{
            if (!Number.isInteger(value)) {
            callback(new Error('La valeur doit être un entier'));
            } else if (value < 0 || value > 100000) {
              callback(new Error('Le prix doit être compris entre 0 et 100000 €'));
            } else {
              callback();
            }
        };
        let validateBaseloadPower = (rule, value, callback)=>{
            if (!Number.isInteger(value)) {
                callback(new Error('La valeur doit être un entier'));
            } else if (value < 0 || value > 100000) {
                callback(new Error('La puissance du talon doit être comprise entre 0 et 100000 kW'));
            } else {
                callback();
            }
        };
        let validateTanPhi = (rule, value, callback)=>{
            if (!Number.isFinite(value)) {
                callback(new Error('La valeur doit être un nombre à virgule'));
            } else if (value <= 0) {
                callback(new Error('Le Tan Phi doit être supérieur à 0'));
            } else {
                callback();
            }
        };
        let validateBatteryPower = (rule, value, callback)=>{
            if (!Number.isInteger(value)) {
                callback(new Error('La valeur doit être un entier'));
            } else if (value <= 0 || value > 1000000) {
                callback(new Error('La puissance de la batterie doit être comprise entre 0 et 1000000 kVAR'));
            } else {
                callback();
            }
        };
        let validateZipCode = (rule, value, callback) => {
            if (!/^\d{5}$/.test(value)) {
                callback(new Error('Le code postal doit contenir 5 chiffres'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            form: {
                company: '',
                facility: '',
                client: '',
                address: '',
                city: '',
                zip_code: undefined,
                energy_meter: '',
                energy_meter_name: '',
                subscribed_power_kva: 0,
                mwh_price: 0,
                baseload_power_is_known: true,
                baseload_power_kw: 0,
                reactive_power_reduction_study: true,
                contractual_tan_phi: 0.0,
                target_tan_phi: 0.0,
                existing_compensation: true,
                battery_power_kvar: 0,
            },
            rules: {
                company: [
                    { required: true, message: 'L\'entreprise est obligatoire', trigger: 'blur' },
                    { min: 1, max: 20, message: 'La longueur maximale est de 20 caractères', trigger: 'change' }
                ],
                facility: [
                    { required: true, message: 'Le nom de l\'établissement est obligatoire', trigger: 'change' },
                    { min: 1, max: 20, message: 'La longueur maximale est de 20 caractères', trigger: 'change' }
                ],
                address: [
                    { required: true, message: 'L\'adresse est obligatoire', trigger: 'change' },
                    { min: 1, max: 30, message: 'La longueur maximale est de 30 caractères', trigger: 'change' }
                ],
                city: [
                    { required: true, message: 'Le nom de la ville est obligatoire', trigger: 'change' }
                ],
                zip_code: [
                    { required: true, message: 'Le code postal est obligatoire', trigger: 'change' },
                    { validator: validateZipCode, trigger: 'blur' },
                ],
                client: [
                    { required: true, message: 'Le client est obligatoire', trigger: 'change' },
                    { min: 1, max: 20, message: 'La longueur maximale est de 20 caractères', trigger: 'change' },
                ],
                energy_meter: [
                    { required: true, message: 'Le compteur d\'énergie est obligatoire', trigger: 'change' }
                ],
                energy_meter_name: [
                    { required: true, message: 'Le numéro du compteur d\'énergie est obligatoire', trigger: 'change' },
                    { validator: validateEnergyMeterName, trigger:'blur'}
                ],
                subscribed_power_kva: [
                    { required: true, message: 'La puissance souscrite est obligatoire', trigger: 'change' },
                    { type: 'number', message: 'La puissance souscrite doit être un nombre', trigger: 'change' },
                    { validator: validateSubscribedPower, trigger: 'blur' },
                ],
                mwh_price: [
                    { required: true, message: 'Le prix du MWh est obligatoire', trigger: 'change' },
                    { type: 'number', message: 'Le prix du MWh doit être un nombre', trigger: 'change' },
                    { validator: validatePrice, trigger: 'blur' },
                ],
                baseload_power_kw: [
                    { required: true, message: 'La puissance du talon est obligatoire', trigger: 'change' },
                    { type: 'number', message: 'La puissance du talon doit être un nombre', trigger: 'change' },
                    { validator: validateBaseloadPower, trigger: 'blur' },
                ],
                contractual_tan_phi: [
                    { required: true, message: 'Le Tan Phi contractuel est obligatoire', trigger: 'change' },
                    { type: 'number', message: 'Le Tan Phi contractuel doit être un nombre', trigger: 'change' },
                    { validator: validateTanPhi, trigger: 'blur' },
                ],
                target_tan_phi: [
                    { required: true, message: 'Le Tan Phi cible est obligatoire', trigger: 'change' },
                    { type: 'number', message: 'Le Tan Phi cible doit être un nombre', trigger: 'change' },
                    { validator: validateTanPhi, trigger: 'blur' },
                ],
                existing_compensation: [
                    { required: true, message: 'La compensation existante est obligatoire', trigger: 'change' }
                ],
                battery_power_kvar: [
                    { required: true, message: 'La puissance de la batterie est obligatoire', trigger: 'change' },
                    { type: 'number', message: 'La puissance de la batterie doit être un nombre', trigger: 'change' },
                    { validator: validateBatteryPower, trigger: 'blur' },
                ]
            },
        };
    },
    computed: {
        ...mapGetters([
            'site',
            'user',
            'currentUser',
            'currentSite',
            'userIsAtLeastManager',
            'energyMetersSite',
            'energyMetersPrefix',
            'currentEnergyMeterNames'
        ]),
        userSite () {
            return this.currentSite;
        },
        pageTitle () {
            return this.userSite ? this.userSite.company : 'Nouveau site';
        },
        pageDescription () {
            return this.userSite ? `Modifer les informations du ${this.userSite.company}` : 'Créer un nouveau site';
        },
        customers (){
            let availableCustomers = this.user.filter((user) => user.level === 'simpleuser' && this.currentUser !== user.uid);
            return availableCustomers;
        },
        energyMeterFullName(){
            return this.energyMetersPrefix(this.form.energy_meter) + this.form.energy_meter_name
        }

    },
    created () {
        let siteUid = this.$route.params.siteUid;
        // If we access the component before selecting a site
        if(siteUid && this.currentSite){
            this.setForm(this.currentSite);
        }
        if (this.userSite){
            this.form.company = this.userSite.company;
            this.form.facility = this.userSite.facility;
            this.form.city = this.userSite.city;
            this.form.zip_code = this.userSite.zip_code;
            this.form.address = this.userSite.address;
            this.form.client = this.userSite.client;
            this.form.mwh_price = this.userSite.mwh_price;
            this.form.energy_meter = this.userSite.energy_meter;
            this.form.energy_meter_name = this.getEnergyMeterNumber(this.userSite.energy_meter_name);
            this.form.subscribed_power_kva = this.userSite.subscribed_power_kva;
            this.form.baseload_power_is_known = this.userSite.baseload_power_is_known;
            this.form.baseload_power_kw = this.userSite.baseload_power_kw;
            this.form.reactive_power_reduction_study = this.userSite.reactive_power_reduction_study;
            this.form.contractual_tan_phi = this.userSite.contractual_tan_phi;
            this.form.target_tan_phi = this.userSite.target_tan_phi;
            this.form.existing_compensation = this.userSite.existing_compensation;
            this.form.battery_power_kvar = this.userSite.battery_power_kvar;
        }
    },
    methods: {
        leaveSite(){
            this.$router.go(-1);
        },
        setForm(currentSite){
            this.form.company = currentSite.company;
            this.form.facility = currentSite.facility;
            this.form.city = currentSite.city;
            this.form.zip_code = currentSite.zip_code;
            this.form.address = currentSite.address;
            this.form.client = currentSite.client;
            this.form.mwh_price = currentSite.mwh_price;
            this.form.energy_meter = currentSite.energy_meter;
            this.form.energy_meter_name = this.getEnergyMeterNumber(currentSite.energy_meter_name)
            this.form.subscribed_power_kva = currentSite.subscribed_power_kva;
            this.form.baseload_power_is_known = currentSite.baseload_power_is_known;
            this.form.baseload_power_kw = currentSite.baseload_power_kw;
            this.form.reactive_power_reduction_study = currentSite.reactive_power_reduction_study;
            this.form.contractual_tan_phi = currentSite.contractual_tan_phi;
            this.form.target_tan_phi = currentSite.target_tan_phi;
            this.form.existing_compensation = currentSite.existing_compensation;
            this.form.battery_power_kvar = currentSite.battery_power_kvar;
        },
        getEnergyMeterNumber(energyMeterName) {
            const match = energyMeterName.match(/\d+$/);
            return match ? parseInt(match[0]) : null;
        },
        resetReactiveStudyFields() {
            this.form.contractual_tan_phi = 0.0;
            this.form.target_tan_phi = 0.0;
            this.form.existing_compensation = false;
            this.form.battery_power_kvar = 0;
        },
        resetExistingCompensationFields() {
            this.form.battery_power_kvar = 0;
        },
        async save () {
            this.$refs.siteForm.validate( valid => {
                if (valid) {
                    this.$set(this, 'loading', true);
                    // save in concrete
                    let siteMethod = this.userSite ? 'patchItem' : 'createItem';

                    let siteData = { ...this.form };
                    siteData.energy_meter_name = this.energyMeterFullName;

                    let declarationUpdated = false;
                    if (siteMethod === 'patchItem' && this.userSite) {
                        const fields = this.$store.state.siteDeclarationFields || [];
                        declarationUpdated = fields.some(field => this.userSite[field] !== siteData[field]);
                    }
                    const siteItem = this.userSite ? Object.assign({
                        uid: this.userSite.uid,
                        url: this.userSite.url
                    }, siteData) : siteData;

                    if (!this.userSite){
                        siteItem.salesperson_uid = this.currentUser.uid;
                    }

                    this.$store.dispatch(siteMethod, {
                        item: siteItem,
                        model: 'site',
                        url: 'site/'
                    // eslint-disable-next-line
                    }).then(async (res) => {
                        if (siteMethod === 'patchItem') {
                            await this.$store.dispatch('resetSimulationData', {
                                item: siteItem,
                                itemType: 'site',
                                declarationUpdated: declarationUpdated
                            });
                        }
                        this.$notify({
                            title: 'Enregistré',
                            message: 'Site enregistré avec succès',
                            type: 'success'
                        });
                        this.$set(this, 'loading', false);
                        this.leaveSite();
                    }).catch(err => {
                        this.$set(this, 'loading', false);
                        this.$notify({
                            title: 'Erreur',
                            message: err.message,
                            type: 'error'
                        });
                    });
                } else {
                    this.$set(this, 'loading', false);
                    this.$notify({
                        title: 'Erreur',
                        message: 'Merci de vérifiez que les champs sont bien renseignés',
                        type: 'error'
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss">
.audit {
    .form-container{
        .el-form.site-form {
            display: flex;
            flex-wrap: wrap;
            gap: 3rem;
            .form-part {
                flex-basis: calc(50% - 1.5rem);
            }
        }
        .button-container{
            flex-grow: 1;
            display: flex;
            justify-content: flex-end;
        }
    }
    
}

.audit-number-label {
    margin: 0;
    padding: 0;
}
.audit-number-input{
    margin-top:  1em;
}
.audit-help {
    margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Site/index.vue